import React from 'react';
import { OtpWhatsAppButton } from '../../components/ui';
import { fmtDateTime } from '../../utils/helpers';

const STEPS = ['mobile', 'otp', 'password'];

// Desktop Forgot password — centred card, one step at a time.
export default function ForgotPasswordDesktop({ vm }) {
  const {
    step, mobile, setMobile, otp, setOtp, pw, setPw, confirm, setConfirm, show, setShow,
    busy, err, reused, submitMobile, submitOtp, submitPassword, resend, back, toLogin,
  } = vm;
  const errBox = err && <div style={{ color: 'var(--danger)', fontSize: 13, marginBottom: 10 }}>{err}</div>;

  return (
    <div className="center-screen">
      <div className="card" style={{ width: '100%', maxWidth: 380 }}>
        <div className="card-pad" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 24, fontWeight: 800, color: 'var(--brand)' }}>Forgot password</div>
          <div className="auth-steps" style={{ marginTop: 10 }}>
            {STEPS.map((s, i) => <span key={s} className={i <= STEPS.indexOf(step) ? 'on' : ''} />)}
          </div>

          {step === 'mobile' && (
            <form onSubmit={submitMobile} style={{ textAlign: 'left' }}>
              <div className="muted" style={{ fontSize: 13, marginBottom: 12, textAlign: 'center' }}>
                Enter your registered mobile number. We will send a code to its WhatsApp.
              </div>
              <label className="field">Mobile Number
                <input type="tel" autoComplete="tel-national" name="mobile" value={mobile} placeholder="10-digit mobile" autoFocus
                  onChange={(e) => setMobile(e.target.value)} />
              </label>
              {errBox}
              <button className="btn primary" style={{ width: '100%' }} disabled={busy}>
                {busy ? 'Sending OTP…' : 'Send OTP on WhatsApp'}
              </button>
            </form>
          )}

          {step === 'otp' && (
            <form onSubmit={submitOtp} style={{ textAlign: 'left' }}>
              <div className="muted" style={{ fontSize: 13, marginBottom: 12, textAlign: 'center' }}>
                {reused
                  ? `Use the OTP already sent to WhatsApp ${mobile} at ${fmtDateTime(reused)}. It is valid for 1 hour, so no new code was sent.`
                  : `OTP sent to WhatsApp ${mobile} (valid for 1 hour).`}
              </div>
              <label className="field">4-digit OTP
                <input type="tel" maxLength={4} value={otp} autoFocus autoComplete="one-time-code" className="auth-mobile-otp"
                  onChange={(e) => setOtp(e.target.value)} />
              </label>
              <OtpWhatsAppButton />
              {errBox}
              <button className="btn primary" style={{ width: '100%' }} disabled={busy}>
                {busy ? 'Verifying…' : 'Verify OTP'}
              </button>
              <div style={{ textAlign: 'center', marginTop: 10, fontSize: 13 }}>
                <button type="button" className="linklike" onClick={resend} disabled={busy}>Resend OTP</button>
              </div>
            </form>
          )}

          {step === 'password' && (
            <form onSubmit={submitPassword} style={{ textAlign: 'left' }}>
              <div className="muted" style={{ fontSize: 13, marginBottom: 12, textAlign: 'center' }}>
                OTP verified. Choose a new password for {mobile}.
              </div>
              <label className="field">New Password
                <input type={show ? 'text' : 'password'} autoComplete="new-password" value={pw} placeholder="4 to 20 characters" autoFocus
                  onChange={(e) => setPw(e.target.value)} />
              </label>
              <label className="field">Confirm Password
                <input type={show ? 'text' : 'password'} autoComplete="new-password" value={confirm} placeholder="Re-enter password"
                  onChange={(e) => setConfirm(e.target.value)} />
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, marginBottom: 12 }}>
                <input type="checkbox" checked={show} style={{ width: 'auto' }} onChange={(e) => setShow(e.target.checked)} />
                Show password
              </label>
              {errBox}
              <button className="btn primary" style={{ width: '100%' }} disabled={busy}>
                {busy ? 'Saving…' : 'Save & Sign In'}
              </button>
            </form>
          )}

          <div className="muted" style={{ marginTop: 14, fontSize: 13, display: 'flex', justifyContent: 'space-between' }}>
            <button type="button" className="linklike" onClick={back}>Back</button>
            <button type="button" className="linklike" onClick={toLogin}>Back to Sign In</button>
          </div>
        </div>
      </div>
    </div>
  );
}
